/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum PageActivityAction {
  created = "created",
  updated = "updated",
  started = "started",
  snapshotted = "snapshotted",
  published = "published",
}

export enum PageActivityActionSubject {
  comment = "comment",
  page = "page",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FeedCardAllActivityQuery
// ====================================================

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedPage_user_photos {
  value: string | null;
  isPrimary: boolean | null;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedPage_user {
  id: string | null;
  displayName: string | null;
  photos: (FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedPage_user_photos | null)[] | null;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedPage {
  timestamp: string;
  action: PageActivityAction;
  actionSubject: PageActivityActionSubject;
  groupSize: number;
  user: FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedPage_user;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventUpdatedPage_user_photos {
  value: string | null;
  isPrimary: boolean | null;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventUpdatedPage_user {
  id: string | null;
  displayName: string | null;
  photos: (FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventUpdatedPage_user_photos | null)[] | null;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventUpdatedPage {
  timestamp: string;
  action: PageActivityAction;
  actionSubject: PageActivityActionSubject;
  pageVersion: number;
  groupSize: number;
  user: FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventUpdatedPage_user;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedComment_comment_links {
  webui: string | null;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedComment_comment {
  id: string;
  links: FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedComment_comment_links;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedComment_user_photos {
  value: string | null;
  isPrimary: boolean | null;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedComment_user {
  id: string | null;
  displayName: string | null;
  photos: (FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedComment_user_photos | null)[] | null;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedComment {
  timestamp: string;
  action: PageActivityAction;
  actionSubject: PageActivityActionSubject;
  groupSize: number;
  comment: FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedComment_comment;
  user: FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedComment_user;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventStartedPage_user_photos {
  value: string | null;
  isPrimary: boolean | null;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventStartedPage_user {
  id: string | null;
  displayName: string | null;
  photos: (FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventStartedPage_user_photos | null)[] | null;
  __typename: "AtlassianUser";
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventStartedPage {
  timestamp: string;
  action: PageActivityAction;
  actionSubject: PageActivityActionSubject;
  pageVersion: number;
  groupSize: number;
  user: FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventStartedPage_user;
  __typename: "PageActivityEventStartedPage";
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventSnapshottedPage_user_photos {
  value: string | null;
  isPrimary: boolean | null;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventSnapshottedPage_user {
  id: string | null;
  displayName: string | null;
  photos: (FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventSnapshottedPage_user_photos | null)[] | null;
  __typename: "AtlassianUser";
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventSnapshottedPage {
  timestamp: string;
  action: PageActivityAction;
  actionSubject: PageActivityActionSubject;
  pageVersion: number;
  groupSize: number;
  user: FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventSnapshottedPage_user;
  __typename: "PageActivityEventSnapshottedPage";
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventPublishedPage_user_photos {
  value: string | null;
  isPrimary: boolean | null;
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventPublishedPage_user {
  id: string | null;
  displayName: string | null;
  photos: (FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventPublishedPage_user_photos | null)[] | null;
  __typename: "AtlassianUser";
}

export interface FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventPublishedPage {
  timestamp: string;
  action: PageActivityAction;
  actionSubject: PageActivityActionSubject;
  pageVersion: number;
  groupSize: number;
  user: FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventPublishedPage_user;
  __typename: "PageActivityEventPublishedPage";
}

export type FeedCardAllActivityQuery_pageActivity_nodes = FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedPage | FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventUpdatedPage | FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedComment | FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventStartedPage | FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventSnapshottedPage | FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventPublishedPage;

export interface FeedCardAllActivityQuery_pageActivity_pageInfo {
  endCursor: string;
  hasNextPage: boolean;
}

export interface FeedCardAllActivityQuery_pageActivity {
  nodes: (FeedCardAllActivityQuery_pageActivity_nodes | null)[];
  pageInfo: FeedCardAllActivityQuery_pageActivity_pageInfo;
}

export interface FeedCardAllActivityQuery {
  pageActivity: FeedCardAllActivityQuery_pageActivity;
}

export interface FeedCardAllActivityQueryVariables {
  contentId: string;
  after?: string | null;
  fromDate?: string | null;
}
